const Banner = '/assets/santarosa/general/rosa-banner.webp';
const HeaderLogo = '/assets/santarosa/general/santarosa-header-logo.png';
const FooterLogo = '/assets/santarosa/general/santarosa-footer-logo-white.png';

const BookingInActive = '/assets/santarosa/general/booking-white.svg';
const BookingActive = '/assets/santarosa/general/booking.svg';
const CancelInActive = '/assets/santarosa/general/cancel-white.svg';
const CancelActive = '/assets/santarosa/general/cancel.svg';
const ChangeInActive = '/assets/santarosa/general/cambiar-white.svg';
const ChangeActive = '/assets/santarosa/general/cambiar.svg';


const Whatsapp = '/assets/santarosa/icons/whatsapp.svg';
const Email = '/assets/santarosa/icons/email.svg';

const EmailOffice = '/assets/santarosa/icons/email-icon.svg';
const RosaPhone = '/assets/santarosa/icons/phone-icon.svg';

const HeadPhone = '/assets/santarosa/icons/headphone.svg';
const YellowLine = '/assets/santarosa/icons/line.svg';

const OriginIcon = '/assets/santarosa/icons/origin-new.svg';
const DestinationIcon = '/assets/santarosa/icons/destination-new.svg';
const pin = '/assets/santarosa/icons/destination-new.svg';
const CalendarIcon = '/assets/santarosa/icons/calendar.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/assets/santarosa/icons/animation.gif';
const pnr = '/assets/santarosa/general/pnr.svg';

const PopupIcon = '/assets/santarosa/general/Pop-up.jpg';

// Icons Section
const ist = '/assets/santarosa/tower/first.png';
const second = '/assets/santarosa/icons/bus.svg';
const third = '/assets/santarosa/icons/box.png';
const close = '/assets/santarosa/icons/close.svg';

const success = '/assets/santarosa/icons/success.png';
const failure = '/assets/santarosa/icons/failure.png';

const tick = '/assets/santarosa/icons/success.png';
const heartOn = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/santarosa/icons/user-circular.png';
const trips = '/assets/santarosa/icons/mytrips.png';
const cards = '/assets/santarosa/icons/card.png';
const wallet = '/assets/santarosa/icons/rechargewallet.png';
const transaction = '/assets/santarosa/icons/transfer-money.png';
const otp = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';

const paso_1 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const paso_2 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargePoints-Orange.svg';
const paso_3 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ID-Orange.svg';
const paso_4 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tickets-Orange.svg';
const pay = '/assets/santarosa/icons/Santa-Rosa-pay.png'


const santarosaIcons = [

	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: Banner, name: 'Banner' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },

	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: pin, name: 'pin' },
	{ icon: CalendarIcon, name: 'Calendar' },

	{ icon: BookingInActive, name: 'BIA' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: ChangeActive, name: 'CTA' },
	{ icon: ChangeInActive, name: 'CTIA' },


	{ icon: PopupIcon, name: 'Popup' },

	{ icon: Whatsapp, name: 'Whatsapp' },
	{ icon: Email, name: 'Email' },
	{ icon: EmailOffice, name: 'emailoffice' },

	{ icon: RosaPhone, name: 'rosaphone' },
	{ icon: HeadPhone, name: 'Headphone' },
	{ icon: YellowLine, name: 'Line' },

	{ icon: animation, name: 'animation' },
	{ icon: checkboxIcon, name: 'Checkbox' },

	// Icons Section
	{ icon: ist, name: 'ist' },
	{ icon: second, name: 'second' },
	{ icon: third, name: 'third' },
	{ icon: pnr, name: 'pnr' },
	{ icon: close, name: 'close' },

	{ icon: pay, name: 'operatorPay' },
];

export default santarosaIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/santarosaIcons.js